import { Link } from "react-router-dom";
import { dramaCategories } from "@/mocks/dramas";

export default function CategoryEntry() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
          <i className="ri-apps-2-line text-primary-500"></i>
          按类型浏览
        </h2>
        <Link
          to="/category"
          className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
        >
          全部剧集
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {dramaCategories.map((category) => (
          <Link
            key={category.key}
            to={`/category?type=${encodeURIComponent(category.key)}`}
            className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-3 py-3 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-primary-950">
              <i className={`${category.icon} text-lg`}></i>
            </span>
            <span className="min-w-0">
              <span className="block truncate text-sm font-medium text-foreground-900">{category.key}</span>
              <span className="block truncate text-[11px] text-foreground-500">{category.desc.slice(0, 12)}…</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}